import {Button, Card, Col, Row} from "react-bootstrap";
import {Link} from "react-router";
import {useAuth} from "../auth/AuthContext";

export function HomePage() {
    const {user} = useAuth();
    return (
        <>
            <div className="py-5 mb-4">
                <h1 className="display-5 fw-semibold">Tristar Advanced Software</h1>
                <p className="lead text-body-secondary col-lg-8">
                    Audio software for producers and sound designers.
                </p>
                {user ? (
                    <Button as={Link as any} to="/account/licenses" size="lg">My licences</Button>
                ) : (
                    <Button as={Link as any} to="/login" size="lg">Sign in</Button>
                )}
            </div>
            <Row className="g-4">
                <Col md={6}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>TSA-1</Card.Title>
                            <Card.Text>
                                A synthesizer plug-in and standalone app. Each licence can be active on two computers at a
                                time. Activate it from the plug-in's licence dialog, and see or free your computers
                                under <Link to="/account/licenses">My licences</Link>.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>Your account</Card.Title>
                            <Card.Text>
                                Change your display name, email address or password on
                                your <Link to="/account/profile">profile</Link>.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
}
